import React, { useEffect, useState } from 'react'
import { Autocomplete, TextField, CircularProgress } from '@mui/material'
import CustomerApi from '../../../api/CustomerApi'
import useAuth from '../../../hooks/useAuth'
import { CustomerEntity } from 'types/CustomerEntity'

const customerApi = new CustomerApi()
const sortByName = (a: { name: string }, b: { name: string }) => (a.name > b.name ? 1 : a.name < b.name ? -1 : 0)

function CustomerSelect({
    value,
    onChange,
    label = 'Välj kund',
    error,
    helperText,
}: {
    value?: CustomerEntity | null
    onChange: (val: CustomerEntity | null) => void
    label?: string
    error?: boolean
    helperText?: string
}) {
    const [customers, setCustomers] = useState<CustomerEntity[]>([])
    const [loading, setLoading] = useState(false)
    const { isAuthenticated } = useAuth()

    useEffect(() => {
        async function fetchData() {
            if (!isAuthenticated) return
            setLoading(true)
            try {
                let customers = await customerApi.adminAllCustomers()
                customers = customers.sort(sortByName)
                setCustomers(customers)
            } catch (error) {
                console.error('Error fetching customers:', error)
            } finally {
                setLoading(false)
            }
        }
        void fetchData()
    }, [isAuthenticated]) // Runs only when `isAuthenticated` changes

    return (
        <Autocomplete
            options={customers}
            getOptionLabel={(option) => option.name}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant='outlined'
                    error={error}
                    helperText={helperText}
                    slotProps={{
                        ...params.slotProps,

                        input: {
                            ...params.slotProps.input,
                            endAdornment: (
                                <>
                                    {loading ? <CircularProgress color='inherit' size={20} /> : null}
                                    {params.slotProps.input.endAdornment}
                                </>
                            ),
                        },
                    }}
                />
            )}
            value={value}
            onChange={(event, newValue) => onChange(newValue)}
            isOptionEqualToValue={(option, value) => option.id === value?.id}
            loading={loading}
        />
    )
}

export default CustomerSelect
